export default {"src":"/_next/static/media/mana.b681faaf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};